import React from 'react';

/* CTA is now part of the Footer component, so this is a spacer/pass-through */
const CTASection = () => {
  return null;
};

export default CTASection;
